import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Nav, NavItem } from 'react-bootstrap';

import Fields from './fields';
import Tasks from './tasks';
import Stages from './stages';

export default function Playbook({ playbook, playbooks, stage }) {
  const [selectedTab, setSelectedTab] = useState('fields');

  return (
    <div className="playbook">
      <Stages playbook={playbook} />
      <Nav
        activeKey={selectedTab}
        bsStyle="pills"
        className="mb-5"
        onSelect={setSelectedTab}
      >
        <NavItem eventKey="fields" key="fields">Data Fields</NavItem>
        <NavItem eventKey="tasks" key="tasks">Deal Tasks</NavItem>
      </Nav>
      {selectedTab === 'fields' ?
        <Fields playbook={playbook} stage={stage} /> :
        <Tasks playbook={playbook} playbooks={playbooks} stage={stage} />
      }
      
    </div>
  );
}

Playbook.propTypes = {
  playbook: PropTypes.object.isRequired,
  playbooks: PropTypes.array.isRequired,
  stage: PropTypes.object,
};
